import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import UpdateUser from '../../CommonComponents/UpdateUser';
import FallbackCard from '../../CommonComponents/FallbackCard';
import { showUserForm, removeAssingedProduct } from '../../redux/actions/dashusers';
import AssignMultipleBrands from './AssignMultipleBrands';
import CommonAlert from '../../CommonComponents/CommonAlert';
import ResetPassword from '../../CommonComponents/ResetPassword';
import DashUserRow from './DashUserRow';

const headCells = [
  {
    id: 'full_name',
    numeric: false,
    align: 'left',
    label: 'Name',
  },
  {
    id: 'username',
    numeric: false,
    align: 'left',
    label: 'Username',
  },
  {
    id: 'email',
    numeric: false,
    align: 'left',
    label: 'Email',
  },
  {
    id: 'brands',
    numeric: false,
    align: 'left',
    label: 'Assigned Brands',
  },
  {
    id: 'mobile',
    numeric: false,
    align: 'left',
    label: 'Mobile',
  },
  {
    id: 'Assign',
    numeric: false,
    align: 'left',
    label: 'Assign Product',
  },
  {
    id: 'userType',
    numeric: false,
    align: 'left',
    label: 'User Role',
  },
  {
    id: 'Edit',
    numeric: false,
    align: 'left',
    label: 'Edit',
  },
  {
    id: 'Action',
    numeric: false,
    align: 'left',
    label: 'Action',
  },
  {
    id: 'updatedAt',
    numeric: false,
    align: 'left',
    label: 'Last Active',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    width: 250,
  },
  products: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}));

const DashUserTable = ({
  dashUsers, showForm, visibleForm, removeProduct,
}) => {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('Name');
  const [user, setUser] = React.useState(null);
  const [localState, setLocalState] = React.useState({
    alert: false,
    userId: '',
    productId: '',
  })
  const [resetPass, setResetPass] = React.useState(false)
  const [updateUser, setUpdateUser] = React.useState(null)

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const selectUser = (row) => {
    setUser(row)
    showForm(2)
  }

  const removeMapping = () => {
    const { userId, productId } = localState
    removeProduct(userId, productId, 1)
    setLocalState({ alert: false, userId: '', productId: '' })
  }

  return (
    <div className={classes.root}>
      {dashUsers.length
        ? (
          <div>
            <Paper className={classes.paper}>
              <TableContainer>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size="medium"
                  aria-label="enhanced table"
                >
                  <EnhancedTableHead
                    headCells={headCells}
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    align="left"
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {stableSort(dashUsers, getComparator(order, orderBy))
                      .map((row) => (
                        <DashUserRow
                          key={row.id}
                          row={row}
                          selectUser={selectUser}
                          setResetPass={setResetPass}
                          setUpdateUser={setUpdateUser}
                          setLocalState={setLocalState}
                        />
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>
        )
        : <FallbackCard text="No data found" />}
      {visibleForm === 2
        ? <AssignMultipleBrands user={user} />
        : null}
      {localState.alert
        ? (
          <CommonAlert
            title="Are you sure?"
            onClose={() => setLocalState({ alert: false, userId: '', productId: '' })}
            onAgree={removeMapping}
          />
        )
        : null}
      {resetPass
        ? <ResetPassword userID={resetPass} onClose={() => setResetPass(false)} />
        : null}
      {updateUser
        ? <UpdateUser setModal={setUpdateUser} user={updateUser} userType="manager" />
        : null}
    </div>
  );
};

const mapState = (state) => ({
  dashUsers: state.dashusers.dashUsers,
  visibleForm: state.dashusers.showUserForm,
});

const mapActions = {
  showForm: showUserForm,
  removeProduct: removeAssingedProduct,
};

export default connect(mapState, mapActions)(DashUserTable);
